<template>
<div>
<querytitle>
  <template slot="queryleft">
    <div>年度：</div>
    <div>
        <el-select v-model="yy" size="mini" @change="changeyy">
            <el-option v-for="(item) in yys" :key="item" :label="item" :value="item">
            </el-option>
        </el-select>
    </div>
  </template>
</querytitle>
<el-table :data="itemlist" border style="width:100%;margin-bottom: 20px;" default-expand-all :row-class-name="tableRowClassName" :height="hh" size="mini" row-key="EVA_ID"  :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
  <el-table-column prop="EVA_ID" label="编号" width="150"></el-table-column>
  <el-table-column prop="EVA_OID" label="序号" width="50" align="center"></el-table-column>
  <el-table-column prop="EVA_NAME" label="测评项目"></el-table-column>
  <el-table-column prop="NEWSCS" label="材料总数" width="70" align="center"></el-table-column>
  <el-table-column prop="IMGS" label="图片张数"  width="70" align="center"></el-table-column>
  <el-table-column label="操作" width="180">
    <template slot-scope="scope">     
     <el-link  type="danger" icon="el-icon-view" :href="'api/newsevalistshow?eva_id='+scope.row.EVA_ID+'&adv_id='+CU.cu.orgid"  target="_blank" size="mini">材料查看</el-link >
     <el-link  @click="downzipfile(scope)" type="success" icon="el-icon-download" circle size="mini">图片打包</el-link>
     <!-- :href="'api/RepEvaImgsZip?EVA_TYPE='+scope.row.EVA_ID" target="_blank" -->
    </template>
  </el-table-column>
</el-table>
</div>
</template>
<style>
  .el-table .warning-row {
    background: #f6f6f6;
  }

  .el-table .success-row {
    background: #ffffff;
  }
</style>
<script>
import querytitle from '@/components/querytitle'
import fileimportbutton from '@/components/fileimportbutton'
export default {
components: {
  querytitle,fileimportbutton
},
data() {
  return {
    hh: 500,
    loading:false,
    addflag: false,
    itemlist: [],
    itemindex: 0,
    itemedit: {},
    dialogFormVisible: false,
    rt: 0,
    currentPage: 1,
    pagesize: 10,
    pars:{objname:'eva_rules'},
    yys:[],
    types:[],
    yy:'',
    evatype:''
  };
},
created() {
  this.hh = document.documentElement.clientHeight - 210;
  this.getyears();
},
methods: {
  tableRowClassName({row, rowIndex}) {
    if (row.EVA_LEVEL=== 1) {
      return 'warning-row';
    } else if (row.EVA_LEVEL === 2) {
      return 'success-row';
    }
    return '';
  },
  getyears(){
        let that = this
        that.GetData("Years", {},function (res) {
          that.yys = res.data.data
          that.yy = res.data.yy
          that.getlist();
          //that.getevatype(that.yy);

        },function (err) {
          that.$alert(err, {title: "错误"});
        }
      );
  },
  changeyy(newval){
    this.yy = newval
    this.getlist();
    //this.getevatype(this.yy);
  },
  downzipfile(par) {
    let that = this
    if(par.row.IMGS<1){
      that.$alert('当前测评项目暂时无图片！', {title: "错误"});
      return
    }
    that.GetData('RepEvaImgsZip',{EVA_TYPE:par.row.EVA_ID,orgid:that.CU.cu.orgid},function(res){
      window.open(res.data.fileurl);
    },function(err){
      console.log(err)
        that.$message({
          message: err,
          type: 'warning'
        })
    })
  },
    getlist() {
        let that = this
        let pars = {yy:that.yy,adv_id: that.CU.cu.orgid}
        that.GetData("Flow/RepEvasUnit", pars,function (res) {
          that.itemlist = res.data.data;
        },function (err) {
            console.log(err)
          that.$alert(err, {title: "错误"});
        }
      );
    }
  }
};
</script>